<template>
  <div data-v-24230dbb="" data-v-e5781868="" class="liveEntertainment mainContent top50">
    <div data-v-24230dbb="" class="content">
      <div data-v-24230dbb="" class="bannerList">
        <div data-v-24230dbb="" :class="`item box${index < 2 ? index + 1 : 3}`" v-for="(item, index) in gameList" :key="index" v-if="item.app_state == 1" >
          <img data-v-24230dbb="" :src="imgList[index]" />
          <div data-v-24230dbb="" class="title">
            <h1 data-v-24230dbb="">{{ item.name }}</h1>
            <p data-v-24230dbb="" v-if="item.app_state == 1">美女主播 陪您嗨聊</p>
            <p data-v-24230dbb="" v-else>平台维护中</p>
          </div>
          <div data-v-24230dbb="" class="coins" v-if="item.app_state == 1">
            <img data-v-24230dbb="" src="/static/image/amount.39372dec.svg" /><span data-v-24230dbb="">{{ 2078 + index * 120 }}人</span>
          </div>
          <div data-v-24230dbb="" class="gameList" v-if="item.app_state == 1">
            <a data-v-24230dbb="" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" class="btnYellow buttonSolid"
              >立即游戏
              <svg data-v-338e1447="" data-v-24230dbb="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
            <div data-v-24230dbb="" class="btnList"><span data-v-24230dbb="">百家乐</span><span data-v-24230dbb="">龙虎</span><span data-v-24230dbb="">轮盘</span><span data-v-24230dbb="">骰宝</span><span data-v-24230dbb="">竟咪百家乐</span><span data-v-24230dbb="">牛牛</span></div>
          </div>
        </div>
      </div>
      <div data-v-24230dbb="" class="bannerList" v-if="false">
        <div data-v-24230dbb="" class="item box1">
          <img data-v-24230dbb="" src="/static/image/banner1.png_.ecc6963f.webp" />
          <div data-v-24230dbb="" class="title">
            <h1 data-v-24230dbb="">AG国际厅</h1>
            <p data-v-24230dbb="">单注最高200万 豪客首选</p>
          </div>
          <div data-v-24230dbb="" class="coins"><img data-v-24230dbb="" src="/static/image/amount.39372dec.svg" /><span data-v-24230dbb="">2078人</span></div>
          <div data-v-24230dbb="" class="gameList">
            <a data-v-24230dbb="" @click="$parent.openGamePage('ag', '1', '')" class="btnYellow buttonSolid"
              >立即游戏
              <svg data-v-338e1447="" data-v-24230dbb="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
            <div data-v-24230dbb="" class="btnList"><span data-v-24230dbb="">百家乐</span><span data-v-24230dbb="">龙虎</span><span data-v-24230dbb="">轮盘</span><span data-v-24230dbb="">骰宝</span><span data-v-24230dbb="">竟咪百家乐</span><span data-v-24230dbb="">牛牛</span></div>
          </div>
        </div>
        <div data-v-24230dbb="" class="item box2">
          <img data-v-24230dbb="" src="/static/image/banner2.png_.53a21e25.webp" />
          <div data-v-24230dbb="" class="title">
            <h1 data-v-24230dbb="">BG旗舰厅</h1>
            <p data-v-24230dbb="">美女主播 陪您嗨聊</p>
          </div>
          <div data-v-24230dbb="" class="gameList">
            <a data-v-24230dbb="" @click="$parent.openGamePage('bg', 'videogame', '')" class="btnYellow buttonSolid"
              >立即游戏
              <svg data-v-338e1447="" data-v-24230dbb="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
            <div data-v-24230dbb="" class="btnList">
              <span data-v-24230dbb="">百家乐</span><span data-v-24230dbb="">竞咪百家乐</span><span data-v-24230dbb="">轮盘</span><span data-v-24230dbb="">骰宝</span><span data-v-24230dbb="">龙虎</span><span data-v-24230dbb="">牛牛 </span><span data-v-24230dbb="">三公</span
              ><span data-v-24230dbb="">21点 </span>
            </div>
          </div>
        </div>
        <div data-v-24230dbb="" class="item box3">
          <img data-v-24230dbb="" src="/static/image/banner3.png_.322d7a7e.webp" />
          <div data-v-24230dbb="" class="title">
            <h1 data-v-24230dbb="">BBIN真人</h1>
            <p data-v-24230dbb="">品牌老店 特殊玩法</p>
          </div>
          <div data-v-24230dbb="" class="gameList">
            <a data-v-24230dbb="" @click="$parent.openGamePage('bbin', 'bbviode', '')" class="btnYellow buttonSolid"
              >立即游戏
              <svg data-v-338e1447="" data-v-24230dbb="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
            <div data-v-24230dbb="" class="btnList">
              <span data-v-24230dbb="">百家乐</span><span data-v-24230dbb="">牛牛</span><span data-v-24230dbb="">温州牌九</span><span data-v-24230dbb="">龙虎</span><span data-v-24230dbb="">三公</span><span data-v-24230dbb="">色碟</span><span data-v-24230dbb="">21点</span>
            </div>
          </div>
        </div>
        <div data-v-24230dbb="" class="item box3">
          <img data-v-24230dbb="" src="/static/image/banner4.png_.35419067.webp" />
          <div data-v-24230dbb="" class="title">
            <h1 data-v-24230dbb="">完美真人</h1>
            <p data-v-24230dbb="">荷官互动 360度旋转咪牌</p>
          </div>
          <div data-v-24230dbb="" class="gameList">
            <a data-v-24230dbb="" @click="$parent.openGamePage('wm', 'videogame', '')" class="btnYellow buttonSolid"
              >立即游戏
              <svg data-v-338e1447="" data-v-24230dbb="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
            <div data-v-24230dbb="" class="btnList"><span data-v-24230dbb="">骰宝</span><span data-v-24230dbb="">轮盘</span><span data-v-24230dbb="">百家乐 </span><span data-v-24230dbb="">牛牛 </span></div>
          </div>
        </div>
        <div data-v-24230dbb="" class="item box3">
          <img data-v-24230dbb="" src="/static/image/banner5.png_.3be17024.webp" />
          <div data-v-24230dbb="" class="title">
            <h1 data-v-24230dbb="">OG真人</h1>
            <p data-v-24230dbb="">
              特有的PLAYBOY真人系统，<br data-v-24230dbb="" />
              深受欧美玩家喜欢
            </p>
          </div>
          <div data-v-24230dbb="" class="gameList">
            <a data-v-24230dbb="" @click="$parent.openGamePage('qg', '1', '')" class="btnYellow buttonSolid"
              >立即游戏
              <svg data-v-338e1447="" data-v-24230dbb="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
            <div data-v-24230dbb="" class="btnList"><span data-v-24230dbb="">百家乐</span><span data-v-24230dbb="">轮盘</span><span data-v-24230dbb="">骰宝</span></div>
          </div>
        </div>
        <div data-v-24230dbb="" class="item box3">
          <img data-v-24230dbb="" src="/static/image/banner3.png_.322d7a7e.webp" />
          <div data-v-24230dbb="" class="title">
            <h1 data-v-24230dbb="">DG真人</h1>
            <p data-v-24230dbb="">品牌老店 特殊玩法</p>
          </div>
          <div data-v-24230dbb="" class="gameList">
            <a data-v-24230dbb="" @click="$parent.openGamePage('dg', 'videogame', '')" class="btnYellow buttonSolid"
              >立即游戏
              <svg data-v-338e1447="" data-v-24230dbb="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
            <div data-v-24230dbb="" class="btnList">
              <span data-v-24230dbb="">百家乐</span><span data-v-24230dbb="">牛牛</span><span data-v-24230dbb="">温州牌九</span><span data-v-24230dbb="">龙虎</span><span data-v-24230dbb="">三公</span><span data-v-24230dbb="">色碟</span><span data-v-24230dbb="">21点</span>
            </div>
          </div>
        </div>
        <div data-v-24230dbb="" class="item box3">
          <img data-v-24230dbb="" src="/static/image/banner4.png_.35419067.webp" />
          <div data-v-24230dbb="" class="title">
            <h1 data-v-24230dbb="">欧博真人</h1>
            <p data-v-24230dbb="">荷官互动 360度旋转咪牌</p>
          </div>
          <div data-v-24230dbb="" class="gameList">
            <a data-v-24230dbb="" @click="$parent.openGamePage('allbet', '1', '')" class="btnYellow buttonSolid"
              >立即游戏
              <svg data-v-338e1447="" data-v-24230dbb="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
            <div data-v-24230dbb="" class="btnList"><span data-v-24230dbb="">骰宝</span><span data-v-24230dbb="">轮盘</span><span data-v-24230dbb="">百家乐 </span><span data-v-24230dbb="">牛牛 </span></div>
          </div>
        </div>
        <div data-v-24230dbb="" class="item box3">
          <img data-v-24230dbb="" src="/static/image/banner5.png_.3be17024.webp" />
          <div data-v-24230dbb="" class="title">
            <h1 data-v-24230dbb="">OB真人</h1>
            <p data-v-24230dbb="">
              特有的PLAYBOY真人系统，<br data-v-24230dbb="" />
              深受欧美玩家喜欢
            </p>
          </div>
          <div data-v-24230dbb="" class="gameList">
            <a data-v-24230dbb="" @click="$parent.openGamePage('obgzr', '3', '')" class="btnYellow buttonSolid"
              >立即游戏
              <svg data-v-338e1447="" data-v-24230dbb="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
            <div data-v-24230dbb="" class="btnList"><span data-v-24230dbb="">百家乐</span><span data-v-24230dbb="">轮盘</span><span data-v-24230dbb="">骰宝</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'realPerson',
  data() {
    return {
      gameList: [],
      imgList: [
        '/static/image/banner1.png_.ecc6963f.webp',
        '/static/image/banner2.png_.53a21e25.webp',
        '/static/image/banner3.png_.322d7a7e.webp',
        '/static/image/banner4.png_.35419067.webp',
        '/static/image/banner5.png_.3be17024.webp',
        '/static/image/realbet/allbetr.png',
        '/static/image/realbet/dgzr.png',
        '/static/image/realbet/obzr.png',
      ],
    };
  },
  created() {
    let that = this;
    that.getGameList();
  },
  methods: {
    getGameList() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun.get('/api/game/list', { category: 'realbet' }).then(res => {
        if (res.code == 200) {
          that.gameList = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    //弹出登录框
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    //弹出注册框
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    //弹出忘记密码框
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    let that = this;
    //首页banner
    var mySwiper = new Swiper('.bannerSwiper .swiper', {
      slidesPerView: 'auto',
      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.bannerSwiper .swiper-button-next',
        prevEl: '.bannerSwiper .swiper-button-prev',
      },
    });
    //首页时间轴品牌历程
    var swiperList = new Swiper('.box .swiper-img', {
      navigation: {
        nextEl: '.swiper-img .swiper-button-next',
        prevEl: '.swiper-img .swiper-button-prev',
      },
    });
    var swiper = new Swiper('.k8BrandWay .c .timeline .swiper', {
      navigation: {
        nextEl: '.k8BrandWay .c .timeline .tool.next',
        prevEl: '.k8BrandWay .c .timeline .tool.prev',
      },
    });
    $('.k8BrandWay .c .timeline .swiper .swiper-slide .swiper-content .items .item').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      var u = $(this).index();
      var b = ((u + 1) / 7) * 100;
      console.log(b);
      $(this)
        .parents('.swiper-slide')
        .find('.swiper-content .line .activeState')
        .css('width', b + '%');
      var i = $(this).parents('.swiper-slide').index();
      if (i > 1) {
        for (var t = 0; t < i; t++) {
          if (t > 1) {
            $('.k8BrandWay .c .timeline .swiper .swiper-slide').eq(t).find('.swiper-content .line .activeState').css('width', '100%');
          }
        }
      }
      var m = i * 7;
      var o = m + u;
      // console.log(u, i, o);
      swiperList.slideTo(o, 1000, false);
    });
    //盈利榜
    $('.table table tr').click(function () {
      $('.table table tr').removeClass('active');
      $(this).addClass('active');
      var username = $(this).find('td').eq(1).text();
      var amount = $(this).find('td').eq(2).text();
      $('.profit .user-name').text('会员' + username);
      $('.profit .amount h1').text(amount.replace('元', ''));
    });
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-40ec6794.0b8a6f7d.css';
.liveEntertainment .bannerList[data-v-24230dbb][data-v-fcebbdc2] {
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/realPerson.vue